module.exports = __webpack_public_path__ + "img/venezuela.d3e0982.webp";